export default __webpack_public_path__ + "static/44-6f45cbee5270c75b731687c4a906726f.png";